<template>
  <div class="app-container essay-list">
    <basic-container>
      <avue-crud ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        @current-change="currentChange"
        @refresh-change="refreshChange"
        @size-change="sizeChange"
        @search-change="searchChange"
        @search-reset="searchReset"
        @sort-change="sortChange"
        >
        <template slot="postedByName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.postedBy.id);"
              class="essay-list-container-button">
            {{scope.row.postedByName}}</a>
        </template>

        <template slot="columnName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toCircleDetail(scope.row.circleId);"
              class="essay-list-container-button">
            {{scope.row.columnName}}</a>
        </template>

        <template slot="commentCount"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toCommentList(scope.row.id);"
              class="essay-list-container-button">
            {{scope.row.commentCount}}</a>
        </template>

        <template slot="search">
          <el-form-item label="状态">
            <el-select
              size="small"
              v-model="listQuery.statusFilter"
              >
              <el-option
                v-for="item in statusOptions"
                :key="item.id"
                :label="item.text"
                :value="item.id"
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布时间">
            <el-date-picker
              type="daterange"
              v-model="listQuery.postTime"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small">
            </el-date-picker>
          </el-form-item>
        </template>

        <template slot="commentEnabled"
                  slot-scope="scope">
          <el-switch v-model="scope.row.commentEnabled"
                     active-color="#00A854"
                     inactive-color="#F04134"
                     :disabled="!permissions.essay_comment_status"
                     @change="handleCommentUpdate(scope.row,scope.index)">
          </el-switch>
        </template>

        <template slot="menu" slot-scope="scope">
          <el-button type="text"
            v-if="permissions.essay_view"
            icon="el-icon-view"
            size="mini"
            @click="handleView(scope.row,scope.index)">查看</el-button>
          <el-button type="text"
            v-if="permissions.essay_ban && scope.row.isActive && scope.row.isBanned"
            icon="el-icon-upload2"
            size="mini"
            @click="handleSwitchBan(scope.row,scope.index)">上架</el-button>
          <el-button type="text"
            v-if="permissions.essay_ban && scope.row.isActive && !scope.row.isBanned"
            icon="el-icon-download"
            size="mini"
            @click="handleSwitchBan(scope.row,scope.index)">下架</el-button>
          <el-button type="text"
            v-if="permissions.essay_post_update && scope.row.isActive"
            icon="el-icon-edit"
            size="mini"
            @click="handlePostUpdate(scope.row,scope.index)">编辑</el-button>
        </template>
        <template slot="menuLeft">
          <el-button type="primary"
                    @click="createEssay"
                    icon="el-icon-add"
                    size="small"
                    v-if="permissions.essay_post_add">新增</el-button>
          <br /><br />
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>
<script>
import { tableOption, statusOptions } from '@/const/crud/post/essay'
import { fetchPostList, updatePostBanStatus, updatePostCommentStatus } from '@/api/post/post'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      columnId: '',
      memberId: '',
      tableData: [],
      page: {
        total: 0, // 总记录数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      },
      listQuery: {
        current: 1,
        size: 20,
        sortField: 'post_time',
        sortPolicy: 'desc',
        title: '',
        postedByName: '',
        columnName: '',
        statusFilter: '',
        postTime: []
      },
      tableLoading: false,
      tableOption: tableOption,
      statusOptions: statusOptions
    }
  },
  watch: {
    $route () {
      this.columnId = this.$route.query.columnId
      this.memberId = this.$route.query.memberId
      this.getList()
    }
  },
  mounted () {
    this.columnId = this.$route.query.columnId
    this.memberId = this.$route.query.memberId
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions']),
    startTime: function () {
      if (this.listQuery.postTime && this.listQuery.postTime.length > 0) {
        return this.listQuery.postTime[0]
      } else {
        return null
      }
    },
    endTime: function () {
      if (this.listQuery.postTime && this.listQuery.postTime.length > 1) {
        return this.listQuery.postTime[1]
      } else {
        return null
      }
    }
  },
  methods: {
    getParameter(param){
      // 提取url参数值
      let url = location.href
      let reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)")
      let r = url.substr(url.indexOf("\?") + 1).match(reg)
      if (r != null) return unescape(r[2])
      else return null
    },
    getParams () {
      let params =  {
        current: this.listQuery.current,
        size: this.listQuery.size,
        postType: 1,
        circleId: this.columnId,
        title: this.listQuery.title,
        postedBy: this.memberId,
        postedByName: this.listQuery.postedByName,
        circleName: this.listQuery.columnName
      }
      if (this.startTime && this.endTime) {
        params.postStartTime = this.startTime
        let t = new Date(this.endTime)
        t.setDate(t.getDate() + 1)
        params.postEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
      }
      if (this.listQuery.statusFilter === 1) {
        params.isBanned = 0
        params.isActive = 1
      } else if (this.listQuery.statusFilter === 2) {
        params.isBanned = 1
        params.isActive = 1
      } else if (this.listQuery.statusFilter === 3) {
        params.isActive = 0
      }
      if (this.listQuery.sortField) {
        params.sortField = this.listQuery.sortField
        params.sortPolicy = this.listQuery.sortPolicy
      }
      // 获取url对应圈子ID参数值做筛选
      let columnIdParam = this.getParameter("columnId")
      if (columnIdParam != null && columnIdParam.trim() != "")
        params.circleId = columnIdParam
      return params
    },
    getList () {
      this.tableLoading = true
      fetchPostList(this.getParams()).then(response => {
        this.tableData = this.formatData(response.data.data.records)
        this.page.total = response.data.data.total
        this.tableLoading = false
      }).catch(error => {
        this.$message({
          message: '获取文章列表失败',
          type: 'error'
        })
        this.tableLoading = false
      })
    },
    formatData (records) {
      if (Array.isArray(records)) {
        records.forEach(essay => {
          essay.postedByName = essay.postedBy.name
          essay.columnName = essay.circleName
          essay.statusText = essay.isActive ? (essay.isBanned ? '已下架' : '已上架') : '已删除'
          if (!essay.commentCount) { essay.commentCount = 0 }
          if (!essay.favoriteCount) { essay.favoriteCount = 0 }
          if (!essay.rewardCount) { essay.rewardCount = 0 }
          if (essay.lastEditTime == undefined || essay.lastEditTime == null) { essay.lastEditTime = "--" }
        })
      }
      return records
    },
    toMemberDetail(postedById) {
      // 点击作者姓名，链接转到该作者的会员详情
      this.$router.push({
        path: "/upms/member/detail/" + postedById,
      })
    },
    toCircleDetail(circleId) {
      // 点击专栏名称，链接转到该专栏的详情页面
      this.$router.push({
        path: "/post/column/detail/" + circleId,
      })
    },
    toCommentList(curPostId) {
      // 点击评论数，链接转到该文章的评论列表
      this.$router.push({
        path: "/post/comment",
        query: {
          postId: curPostId
        }
      })
    },
    searchReset () {
      this.listQuery.statusFilter = ''
      this.listQuery.postTime = []
      this.searchChange({})
    },
    searchChange (params) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.listQuery.title = params.title
      this.listQuery.postedByName = params.postedByName
      this.listQuery.columnName = params.columnName
      this.getList()
    },
    currentChange (val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange (val) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.page.pageSize = val
      this.listQuery.size = val
      this.getList()
    },
    sortChange (val) {
      // 检查排序对象
      if (val.prop == "id") {
        this.listQuery.sortField = "post_id"
      } else if (val.prop == "commentCount") {
        this.listQuery.sortField = "comment_count"
      } else if (val.prop == "favoriteCount") {
        this.listQuery.sortField = "favorite_count"
      } else if (val.prop == "likeCount") {
        this.listQuery.sortField = "like_count"
      } else if (val.prop == "postTime"){
        this.listQuery.sortField = "post_time"
      } else if (val.prop == "rewardCount"){
        this.listQuery.sortField = "reward_count"
      }
      // 检查排序方式
      if (val.order == 'ascending') {
        this.listQuery.sortPolicy = "asc"
      } else if (val.order == 'descending') {
        this.listQuery.sortPolicy = "desc"
      } else {
        this.listQuery.sortPolicy = ""
      }
      this.getList()
    },
    refreshChange () {
      this.getList()
    },
    handleView (row, index) {
      this.$router.push({
        path: `/post/essay/detail/${row.id}`
      })
    },
    handleSwitchBan (row, index) {
      this.$confirm('是否' + (row.isBanned ? '上架' : '下架') + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updatePostBanStatus({
          id: row.id,
          isBanned: row.isBanned ? 0 : 1
        }).then(response => {
          if (response.data.data) {
            row.isBanned = !row.isBanned
            row.statusText = row.isBanned ? '已下架' : '已上架'
            this.$message({
              message: (row.isBanned ? '下架' : '上架') + '成功',
              type: 'success'
            })
          }
        }).catch(error => {
          this.$message({
            message: (row.isBanned ? '上架' : '下架') + '失败',
            type: 'error'
          })
        })
      })
    },
    handleCommentUpdate(row, index) {
      let obj = {
        id: row.id,
        commentEnabled: row.commentEnabled,
      };
      if (row.id) {
        updatePostCommentStatus(obj);
      }
    },
    createEssay() {
      this.$router.push({path: '/post/essay/add'})
    },
    handlePostUpdate(row) {
      this.$router.push({path: '/post/essay/edit', query: {id: row.id}})
    },
  }
}
</script>

<style lang="scss" scoped>

.essay-list {
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>

